package com.rainbowclubs.rainbow.presentation.messages

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.rainbowclubs.rainbow.data.models.MembershipStatus
import com.rainbowclubs.rainbow.domain.use_cases.home.GetHomeDataUseCase
import com.rainbowclubs.rainbow.presentation.ScreenState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class MessagesViewModel(
    private val clubId: String,
    private val getHomeDataUseCase: GetHomeDataUseCase,
) : ViewModel() {

    private val _screenState = MutableStateFlow<ScreenState<MembershipStatus>>(ScreenState.Loading)
    val screenState: StateFlow<ScreenState<MembershipStatus>> = _screenState.asStateFlow()

    init {
        fetchMembershipStatus()
    }

    fun fetchMembershipStatus() {
        viewModelScope.launch {
            _screenState.value = ScreenState.Loading
            getHomeDataUseCase(clubId)
                .onSuccess { homeResponse ->
                    _screenState.value = ScreenState.Content(
                        homeResponse.membership?.status ?: MembershipStatus.UNKNOWN
                    )
                }
                .onFailure {
                    _screenState.value = ScreenState.Error(it)
                }
        }
    }
}
